// extracted by mini-css-extract-plugin
export default {"input":"_3Rht","error":"_34ij"};